export const formatCompactedValue = (value) => {
  const options = {
    notation: 'compact',
    compactDisplay: 'short',
  };
  const formatter = new Intl.NumberFormat('en-US', options);
  return formatter.format(value);
};

export const formatValue = (value, type = 'text') => {
  if (value === null || value === undefined) return '';

  switch (type) {
    case 'currency-large':
      return `$${Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    case 'currency-small':
      return `$${Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    case 'currency': // Default currency fallback
      return `$${Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    case 'number':
      return Number(value).toLocaleString('en-US');
    case 'date':
      return new Date(value).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    case 'compact':
      return formatCompactedValue(value);
    default:
      return value;
  }
};
